import { useNavigate, useParams } from "@solidjs/router"
import { createEffect, createMemo } from "solid-js"
import { ulid } from "ulid"
import { useAppContext } from "@/context/app"
import { splitUrl } from "@/lib/slug"
import { createPublishersRouter } from "@/routes/publishers-router"

export default function usePublisher() {
  const { db, replicache } = useAppContext()
  const navigate = useNavigate()
  const params = useParams()
  const getPublisher = createMemo(() =>
    db.publisher.get(splitUrl(params.publisherId)),
  )
  const { paths } = createPublishersRouter()

  // Redirect if the post is not found
  createEffect(() => {
    const publisher = getPublisher()
    if (!publisher) {
      navigate(paths().url)
    } else if (publisher.backend) {
      replicache.mutate.setRecentPublisher({
        id: ulid(),
        publisher_id: publisher.id,
        backend: false,
      })
    }
  })

  return getPublisher
}
